import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { Button } from '@/components/atoms/Button/Button';
import { Dialog } from '@/components/atoms/Dialog/Dialog';
import { Icon } from '@/components/atoms/Icon/Icon';

export const AppUpdateDialog = ({
  isDialogVisible,
  onUpdate,
  setIsDialogVisible,
}: AppUpdateDialogProps) => {
  return (
    <Dialog
      title='New update available'
      description='A newer version of the app is now available. Update now for the latest features and improvements!'
      isOpen={isDialogVisible}
    >
      <Stack
        direction='row'
        sx={{ justifyContent: 'center', alignItems: 'center', gap: '1rem' }}
      >
        <Button
          ariaLabel='Not now'
          type='button'
          variant='secondary'
          onPress={() => {
            setIsDialogVisible(false);
          }}
        >
          Not now
        </Button>
        <Button ariaLabel='refresh' type='submit' onPress={onUpdate}>
          <Box component='span' sx={{ mr: '10px', display: 'inline' }}>
            <Icon icon='arrows-rotate' />
          </Box>
          Update
        </Button>
      </Stack>
    </Dialog>
  );
};

interface AppUpdateDialogProps {
  isDialogVisible: boolean;
  onUpdate: () => void;
  setIsDialogVisible: (isOpen: boolean) => void;
}

AppUpdateDialog.displayName = 'AppUpdateDialog';

export default AppUpdateDialog;
